<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/aktivitetslogg">Aktivitetslogg</router-link>
        <router-link tag="li" to="/grafer">Grafer</router-link>
        <router-link tag="li" to="/energimatning">Energimätning</router-link>
      </ul>
      <div class="clear"></div>
    </div>
                 
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row">
          <h2>Just nu drar ditt hem {{ now.w.toFixed(2) }} W från totalt {{ now.nodesOn }} enhet(er)</h2>

          <bar-chart></bar-chart>


          <div class="col-md-3">



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import loadingView from './views/loadingView'
 //import { Bar } from 'vue-chartjs'

  export default {
    name: 'energimatning',
    //mixins: [Bar],
    data: () => ({
      now: {},
        chartdata: {
          labels: ['January', 'February'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [40, 20, 150,15000]
            }
          ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    }),
    mounted () {
      this.renderChart(this.chartdata, this.options)
    },
    created () {
      setTimeout(() => {
       // this.renderChart(this.chartdata, this.options)
      }, 2500)
      this.getRightNow()
    },
    methods: {
      async getRightNow () {
        this.now = (await HTTP.get('/ex/energy')).data.data
      }
    },
    computed: {},
    destroyed () {}
  }
</script>


// WEBPACK FOOTER //
// src/components/energimatning.vue